"use client";

import { useTranslations } from "next-intl";
import { InfiniteScroll } from "@/components/core/InfiniteScroll/InfiniteScroll";
import { useFetchBranchOrders } from "@/hooks/user/useFetchBranchOrders";
import { hasLoadedListItems } from "@/lib/pagination/hasLoadedListItems";
import {
  UserOrdersEmpty,
  UserOrdersProduct,
  UserOrdersProductSkeleton,
} from "./";

export const BranchOrdersTab = () => {
  const t = useTranslations("orders");
  const ordersLeft = useFetchBranchOrders({ limit: 10, side: "left" });
  const ordersRight = useFetchBranchOrders({ limit: 10, side: "right" });

  if (
    (ordersLeft.isLoading || ordersRight.isLoading) &&
    !hasLoadedListItems(ordersLeft) &&
    !hasLoadedListItems(ordersRight)
  ) {
    return (
      <div className="w-full grid grid-cols-2 gap-4">
        {[1, 2, 3, 4].map((id) => (
          <UserOrdersProductSkeleton key={`skeleton-${id}`} />
        ))}
      </div>
    );
  }

  if (
    (ordersLeft.error || ordersRight.error) &&
    !hasLoadedListItems(ordersLeft) &&
    !hasLoadedListItems(ordersRight)
  ) {
    return (
      <div className="w-full py-8">
        <div className="text-center text-semantic-error">
          <p>{t("error.loadBranchOrders")}</p>
          <p className="text-sm mt-2">
            {ordersLeft.error?.message ||
              ordersRight.error?.message ||
              t("error.unknown")}
          </p>
        </div>
      </div>
    );
  }

  const leftOrders =
    ordersLeft.data?.pages.flatMap((page) => page?.data?.result || []) || [];
  const rightOrders =
    ordersRight.data?.pages.flatMap((page) => page?.data?.result || []) || [];

  if (leftOrders.length === 0 && rightOrders.length === 0) {
    return <UserOrdersEmpty description={t("empty.branchEmpty")} />;
  }

  return (
    <div className="w-full grid grid-cols-2 gap-4">
      <div className="flex flex-col gap-4">
        {leftOrders.map((order) => (
          <UserOrdersProduct
            key={`left-${order.id}`}
            order={order}
            user={order.child_user}
          />
        ))}
        <InfiniteScroll query={ordersLeft} className="py-4" />
      </div>

      <div className="flex flex-col gap-4">
        {rightOrders.map((order) => (
          <UserOrdersProduct
            key={`right-${order.id}`}
            order={order}
            user={order.child_user}
          />
        ))}
        <InfiniteScroll query={ordersRight} className="py-4" />
      </div>
    </div>
  );
};
